import type { FC } from "react"
import React from "react"
import { AccordionButton, Flex, HStack, Spacer, Text } from "@chakra-ui/react"
import { CheckIcon } from "@chakra-ui/icons"

type CreateProposalStepHeaderProps = {
  isActive: boolean
  isSuccess: boolean
  currentStep: number
  title: string
  onClick?: () => void
}

const CreateProposalStepHeader: FC<CreateProposalStepHeaderProps> = ({
  isActive,
  isSuccess,
  currentStep,
  onClick = null,
  title,
}) => {
  const buttonBackground = isActive || isSuccess ? "white" : "gray.100"
  const opacity = isActive ? 1 : 0.7

  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <AccordionButton
      disabled
      _hover={{ cursor: "default" }}
      bg={buttonBackground}
      px={{ base: 4, lg: 12 }}
      py={{ base: 6, lg: 9 }}
      onClick={handleClick}
    >
      <HStack width="full">
        <StepIcon currentStep={currentStep} isSuccess={isSuccess} />
        <Text color="purple.900" fontWeight="semibold" opacity={opacity}>
          {title}
        </Text>
        <Spacer />
      </HStack>
    </AccordionButton>
  )
}

export default CreateProposalStepHeader

const StepIcon: FC<{
  isSuccess: boolean
  currentStep: number
}> = ({ isSuccess, currentStep }) => (
  <Flex
    align="center"
    bg={isSuccess ? "purple.500" : "purple.900"}
    borderRadius="full"
    color="white"
    h={8}
    justify="center"
    w={8}
  >
    {isSuccess ? <CheckIcon /> : `${currentStep + 1}`}
  </Flex>
)
